<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"><i></i> </span></p>
<p class="p2"><span class="sz"><i></i> </span></p>
<p class="p3"><span class="sz"><i>For M.P.L. and V.A.L.</i></span></p>
<p class="p3"><span class="sz"><i>the three bravest people I know</i></span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?2ddc41f2